export const NOTES_DATA_REQUEST = 'NOTES_DATA_REQUEST';
export const NOTES_DATA_SUCCESS = 'NOTES_DATA_SUCCESS';
export const NOTES_DATA_FAIL = 'NOTES_DATA_FAIL';
